import React from 'react';
import { ContentfulFilter } from '@jbhi-fi/components/src/hooks/useContentfulEntries/useContentfulEntries';
import { EntryType } from '@jbhi-fi/apis/src/contentful/types';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner/Spinner';
import { SpinnerVariant } from '@jbhi-fi/lanyard-ui/components/Spinner/Spinner.types';
import { CardContext, CardProvider } from '@jbhi-fi/components/src/hooks/useCards';
import { ContentCard } from '@jbhi-fi/components/src/ContentCard';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { HeadingDivider } from '@jbhi-fi/components/src/HeadingDivider/HeadingDivider';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { styles } from './RelatedEntries.css';

export type RelatedEntriesProps = {
  heading: string;
  contentType: EntryType.article | EntryType.competition;
  filter: Omit<ContentfulFilter, 'content_type'> | null;
};

export const RelatedEntries = ({ heading, filter, contentType }: RelatedEntriesProps) => {
  return (
    <CardProvider filters={[{ ...filter, content_type: contentType }]} numCards={6} useLoadingSkeletons={false}>
      <CardContext.Consumer>
        {({ cards, isLoading }) => (
          <div className={styles.container}>
            {heading ? (
              <div className={styles.heading}>
                <HeadingDivider textColor="white" heading={heading} />
              </div>
            ) : null}
            {isLoading ? (
              <div className={styles.loadingContainer}>
                <Spinner variant={SpinnerVariant.light} />
              </div>
            ) : (
              <Carousel
                spaceBetween={10}
                slidesPerView="auto"
                showProgressBar
                showPagination={false}
                fullHeightItems={true}
                arrowColor={palette.primary.light}
              >
                {cards.map((cardProps, index) => (
                  <ContentCard key={index} width={{ xs: '320px', md: '370px' }} {...cardProps} />
                ))}
              </Carousel>
            )}
          </div>
        )}
      </CardContext.Consumer>
    </CardProvider>
  );
};
